// extracted by mini-css-extract-plugin
module.exports = {"plan":"Plan_plan__7Vqx1","plan__highlightText":"Plan_plan__highlightText__DxXyX","plan__icon":"Plan_plan__icon__FJq62","plan__bestSelling":"Plan_plan__bestSelling__XEbL8"};